import {
  useEffect,
  useState,
} from "react";
import {
  Card,
  Grid,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
  Box
} from "@mui/material";
import Chart from "react-google-charts";
import "./style.css";
import api from "../../utils/Url";
import Active from "../../assets/images/Activ.png";
import { useTranslation } from "react-i18next";
import TotalEPCApproved from "../../components/homepage/modal/TotalEPCApproved";
import TotalEPCPending from "../../components/homepage/modal/TotalEPCPending";
import TotalFileModal from "../../components/homepage/modal/TotalFileModal";
import ZoneWiseWardDashboard from "../../components/homepage/Graph/WardBarGraph"
import NoticeBoard from "../../components/homepage/Graph/NoticeBoard";
import StatCard from "../../components/homepage/StatCard";
import ZonePieChart from "../../components/homepage/Graph/ZonePieChart";

const options1 = {
  pieSliceText: "value",
  pieSliceTextStyle: {
    color: "white",
    bold: true,
  },
  slices: {
    0: { offset: 0.1, color: "#3366cc" },
    1: { offset: 0.1, color: "#dc3912" },
  },
  legend: {
    position: "top",
  },
  chartArea: {
    width: "90%",
    height: "80%"
  }
};

export default function HomePage() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [totAdvertisement, setTotAdvertisement] = useState("");
  const [totApplied, setTotApplied] = useState("");
  const [totVacantHolding, setTotVacantHolding] = useState("");
  const [totApproved, setTotApproved] = useState("");
  const [chartData, setChartData] = useState<any>("");
  const [showModal, setShowModal] = useState(false);
  const [selectedZone, setSelectedZone] = useState("Zone 1");
  const [showTotalEPCApproved, setShowTotalEPCApproved] = useState(false);
  const [showTotalEPCPending, setShowTotalEPCPending] = useState(false);
  const [showTotalFileModal, setShowTotalFileModal] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    getChartData();
    getHoardingData();
    const tokenDataString: any = sessionStorage.getItem('token');
  }, []);

  const getChartData = () => {
    const collectData = {
      zoneID: -1,
      user_ID: 0,
    };
    api
      .post(
        `Dashboard/GetDashboardZoneMaster`,
        collectData
      )
      .then((res) => {
        const data = formatChartData(res.data.data);
        setChartData(data);
      })
      .catch((error) => {
        console.error("Error fetching chart data: ", error);
      });
  };

  const formatChartData = (data: any) => {
    const formattedData = [["Zone", "Ward Count", "wardData"]];
    data.forEach((zone: any) => {
      formattedData.push([
        zone.zoneName,
        zone.dashboardWard.length,
        zone.dashboardWard,
      ]);
    });
    return formattedData;
  };

  const getHoardingData = () => {
    api
      .get(`Dashboard/GetDashboardTotalCount`)
      .then((res) => {
        setTotAdvertisement(res.data.data.totalFile);
        setTotApplied(res.data.data.totalIssue);
        setTotVacantHolding(res.data.data.totEpcNotapprove);
        setTotApproved(res.data.data.totEpcapprove);
      });
  };

  const handleChartSelect = (chartWrapper: any) => {
    const selection = chartWrapper.getChart().getSelection();
    if (selection.length === 1) {
      const item = chartData[selection[0].row + 1];
      if (item) {
        setSelectedZone(item[0]);
        setShowModal(true);
      }
    }
  };

  return (
    <Box sx={{
      paddingY: isSmallScreen ? 4 : 2,
    }}>
      <Grid container spacing={isSmallScreen ? 1 : 2}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label={t('text.TotalFile')}
            value={Number(totAdvertisement) || 0}
            iconSrc={Active}
            onClick={() => setShowTotalFileModal(true)}
            isSmallScreen={isSmallScreen}
            theme={theme}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label={t('text.TotalEPCApproved')}
            value={Number(totApproved) || 0}
            iconSrc={Active}
            onClick={() => setShowTotalEPCApproved(true)}
            isSmallScreen={isSmallScreen}
            theme={theme}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label={t('text.TotalEPCPending')}
            value={Number(totVacantHolding) || 0}
            iconSrc={Active}
            onClick={() => setShowTotalEPCPending(true)}
            isSmallScreen={isSmallScreen}
            theme={theme}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label={t('text.TotalFileIssue')}
            value={Number(totApplied) || 0}
            iconSrc={Active}
            isSmallScreen={isSmallScreen}
            theme={theme}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            elevation={4}
            sx={{
              height: isSmallScreen ? '320px' : '380px',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 2,
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                p: 2,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography variant="h6" component="div">
                {t("text.Zone")}
              </Typography>
            </Box>
            <Box sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              p: isSmallScreen ? 1 : 2
            }}>
              <ZonePieChart />
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            elevation={4}
            sx={{
              height: isSmallScreen ? '320px' : '380px',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 2,
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                p: 2,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography variant="h6" component="div">
                {t("text.NoticeBoard")}
              </Typography>
            </Box>
            <Box sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              p: isSmallScreen ? 1 : 2
            }}>
              <NoticeBoard />
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card
            elevation={4}
            sx={{
              height: isSmallScreen ? '400px' : '540px',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 2,
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                p: 2,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography variant="h6" component="div">
                {t("text.WardData")}
              </Typography>
            </Box>
            <Box sx={{
              flexGrow: 1,
              overflow: 'auto',
              p: isSmallScreen ? 1 : 2
            }}>
              <ZoneWiseWardDashboard />
            </Box>
          </Card>
        </Grid>
      </Grid>

      <TotalEPCApproved
        open={showTotalEPCApproved}
        onClose={() => setShowTotalEPCApproved(false)}
      />
      <TotalEPCPending
        open={showTotalEPCPending}
        onClose={() => setShowTotalEPCPending(false)}
      />
      <TotalFileModal
        open={showTotalFileModal}
        onClose={() => setShowTotalFileModal(false)}
      />
    </Box>
  );
}





















// import {
//   useEffect,
//   useState,
// } from "react";
// import {
//   Card,
//   Grid,
//   CardContent,
//   Typography,
//   Divider,
//   useMediaQuery,
//   useTheme,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   IconButton
// } from "@mui/material";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import Chart from "react-google-charts";
// import "./style.css";
// import axios from "axios";
// import api from "../../utils/Url";
// import Active from "../../assets/images/Activ.png";
// import news from "../../assets/images/news.png";
// import Modal from "@mui/material/Modal";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import ListSubheader from "@mui/material/ListSubheader";
// import { VehicleRfid, WeightChart } from "../../type";
// import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
// import Box from "@mui/material/Box";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import { useTranslation } from "react-i18next";
// import { text } from "stream/consumers";
// import TotalEPCApproved from "../../components/homepage/modal/TotalEPCApproved";
// import TotalEPCPending from "../../components/homepage/modal/TotalEPCPending";
// import TotalFileModal from "../../components/homepage/modal/TotalFileModal";
// import ZoneWiseWardDashboard from "../../components/homepage/Graph/WardBarGraph"
// import NoticeBoard from "../../components/homepage/Graph/NoticeBoard";
// import StatCard from "../../components/homepage/StatCard";

// const options1 = {
//   pieSliceText: "value",
//   pieSliceTextStyle: {
//     color: "white",
//     bold: true,
//   },
//   slices: {
//     0: { offset: 0.1, color: "#3366cc" },
//     1: { offset: 0.1, color: "#dc3912" },
//   },
//   legend: {
//     position: "top",
//   },
//   chartArea: {
//     width: "90%",
//     height: "80%"
//   }
// };

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };

// // Custom hook for counting animation
// const useCountUp = (target: number, duration: number = 2000) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const end = target;
//     // If target is 0, don't animate
//     if (end === 0) {
//       setCount(0);
//       return;
//     }

//     const incrementTime = Math.max(1, Math.floor(duration / end));
//     let increment = 1;

//     // For large numbers, increment by larger steps to finish in reasonable time
//     if (end > 1000) {
//       increment = Math.floor(end / 100);
//     }

//     const timer = setInterval(() => {
//       start += increment;
//       setCount(Math.min(start, end));
//       if (start >= end) clearInterval(timer);
//     }, incrementTime);

//     return () => clearInterval(timer);
//   }, [target, duration]);

//   return count;
// };

// export default function HomePage() {
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
//   const [totAdvertisement, setTotAdvertisement] = useState("");
//   const [totApplied, setTotApplied] = useState("");
//   const [totVacantHolding, setTotVacantHolding] = useState("");
//   const [totApproved, setTotApproved] = useState("");
//   const [chartData, setChartData] = useState<any>("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedZone, setSelectedZone] = useState("Zone 1");
//   const [showModal1, setShowModal1] = useState(false);
//   const [hoardingModalData, setHoardingModalData] = useState(false);
//   const [hoardingData, setHoardingData] = useState([]);
//   const [showTotalEPCApproved, setShowTotalEPCApproved] = useState(false);
//   const [showTotalEPCPending, setShowTotalEPCPending] = useState(false);
//   const [showTotalFileModal, setShowTotalFileModal] = useState(false);

//   // Animated values
//   const animatedAdvertisement = useCountUp(Number(totAdvertisement) || 0);
//   const animatedApplied = useCountUp(Number(totApplied) || 0);
//   const animatedVacantHolding = useCountUp(Number(totVacantHolding) || 0);
//   const animatedApproved = useCountUp(Number(totApproved) || 0);

//   const { t } = useTranslation();

//   useEffect(() => {
//     getChartData();
//     getHoardingData();
//     const tokenDataString: any = sessionStorage.getItem('token');
//   }, []);

//   const getChartData = () => {
//     const collectData = {
//       zoneID: -1,
//       user_ID: 0,
//     };
//     api
//       .post(
//         `Dashboard/GetDashboardZoneMaster`,
//         collectData
//       )
//       .then((res) => {
//         const data = formatChartData(res.data.data);
//         setChartData(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching chart data: ", error);
//       });
//   };

//   const formatChartData = (data: any) => {
//     const formattedData = [["Zone", "Ward Count", "wardData"]];
//     data.forEach((zone: any) => {
//       formattedData.push([
//         zone.zoneName,
//         zone.dashboardWard.length,
//         zone.dashboardWard,
//       ]);
//     });
//     return formattedData;
//   };

//   const getHoardingData = () => {
//     api
//       .get(`Dashboard/GetDashboardTotalCount`)
//       .then((res) => {
//         setTotAdvertisement(res.data.data.totalFile);
//         setTotApplied(res.data.data.totalIssue);
//         setTotVacantHolding(res.data.data.totEpcNotapprove);
//         setTotApproved(res.data.data.totEpcapprove);
//       });
//   };

//   const handleChartSelect = (chartWrapper: any) => {
//     const selection = chartWrapper.getChart().getSelection();
//     if (selection.length === 1) {
//       const item = chartData[selection[0].row + 1];
//       if (item) {
//         setSelectedZone(item[0]);
//         setShowModal(true);
//       }
//     }
//   };

//   return (
//     <Box sx={{
//       paddingY: isSmallScreen ? 1 : 2,
//     }}>
//       <Grid container spacing={isSmallScreen ? 1 : 2}>
//         {/* Stats Cards with Animated Values */}
//         {/* <Grid item xs={12} sm={6} md={3}>
//           <Card
//             elevation={4}
//             onClick={() => setShowTotalFileModal(true)}
//             sx={{
//               borderRadius: 2,
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               transition: 'transform 0.3s, box-shadow 0.3s',
//               '&:hover': {
//                 transform: 'translateY(-5px)',
//                 boxShadow: theme.shadows[8]
//               }
//             }}
//           >
//             <CardContent sx={{
//               flexGrow: 1,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'space-between'
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <img
//                   alt="Active"
//                   src={Active}
//                   style={{ height: isSmallScreen ? '40px' : '50px', width: isSmallScreen ? '40px' : '50px' }}
//                 />
//                 <Typography
//                   fontWeight={600}
//                   fontSize={isSmallScreen ? 14 : 16}
//                   noWrap
//                   color={"primary"}
//                   sx={{ ml: 1 }}
//                 >
//                   {t("text.TotalFile")}
//                 </Typography>
//               </Box>
//               <Typography
//                 variant="h4"
//                 color="text.secondary"
//                 sx={{
//                   textAlign: 'right',
//                   mt: 1,
//                   fontSize: isSmallScreen ? '1.5rem' : '2rem'
//                 }}
//               >
//                 <b>{animatedAdvertisement.toLocaleString()}</b>
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             elevation={4}
//             onClick={() => setShowTotalEPCApproved(true)}
//             sx={{
//               borderRadius: 2,
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               transition: 'transform 0.3s, box-shadow 0.3s',
//               '&:hover': {
//                 transform: 'translateY(-5px)',
//                 boxShadow: theme.shadows[8]
//               }
//             }}
//           >
//             <CardContent sx={{
//               flexGrow: 1,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'space-between'
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <img
//                   alt="Active"
//                   src={Active}
//                   style={{ height: isSmallScreen ? '40px' : '50px', width: isSmallScreen ? '40px' : '50px' }}
//                 />
//                 <Typography
//                   fontWeight={600}
//                   fontSize={isSmallScreen ? 14 : 16}
//                   noWrap
//                   color={"primary"}
//                   sx={{ ml: 1 }}
//                 >
//                   {t("text.TotalEPCApproved")}
//                 </Typography>
//               </Box>
//               <Typography
//                 variant="h4"
//                 color="text.secondary"
//                 sx={{
//                   textAlign: 'right',
//                   mt: 1,
//                   fontSize: isSmallScreen ? '1.5rem' : '2rem'
//                 }}
//               >
//                 <b>{animatedApproved.toLocaleString()}</b>
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             elevation={4}
//             onClick={() => setShowTotalEPCPending(true)}
//             sx={{
//               borderRadius: 2,
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               transition: 'transform 0.3s, box-shadow 0.3s',
//               '&:hover': {
//                 transform: 'translateY(-5px)',
//                 boxShadow: theme.shadows[8]
//               }
//             }}
//           >
//             <CardContent sx={{
//               flexGrow: 1,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'space-between'
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <img
//                   alt="Active"
//                   src={Active}
//                   style={{ height: isSmallScreen ? '40px' : '50px', width: isSmallScreen ? '40px' : '50px' }}
//                 />
//                 <Typography
//                   fontWeight={600}
//                   fontSize={isSmallScreen ? 14 : 16}
//                   noWrap
//                   color={"primary"}
//                   sx={{ ml: 1 }}
//                 >
//                   {t("text.TotalEPCPending")}
//                 </Typography>
//               </Box>
//               <Typography
//                 variant="h4"
//                 color="text.secondary"
//                 sx={{
//                   textAlign: 'right',
//                   mt: 1,
//                   fontSize: isSmallScreen ? '1.5rem' : '2rem'
//                 }}
//               >
//                 <b>{animatedVacantHolding.toLocaleString()}</b>
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             elevation={4}
//             sx={{
//               borderRadius: 2,
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               transition: 'transform 0.3s, box-shadow 0.3s',
//               '&:hover': {
//                 transform: 'translateY(-5px)',
//                 boxShadow: theme.shadows[8]
//               }
//             }}
//           >
//             <CardContent sx={{
//               flexGrow: 1,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'space-between'
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <img
//                   alt="Active"
//                   src={Active}
//                   style={{ height: isSmallScreen ? '40px' : '50px', width: isSmallScreen ? '40px' : '50px' }}
//                 />
//                 <Typography
//                   fontWeight={600}
//                   fontSize={isSmallScreen ? 14 : 16}
//                   noWrap
//                   color={"primary"}
//                   sx={{ ml: 1 }}
//                 >
//                   {t("text.TotalFileIssue")}
//                 </Typography>
//               </Box>
//               <Typography
//                 variant="h4"
//                 color="text.secondary"
//                 sx={{
//                   textAlign: 'right',
//                   mt: 1,
//                   fontSize: isSmallScreen ? '1.5rem' : '2rem'
//                 }}
//               >
//                 <b>{animatedApplied.toLocaleString()}</b>
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid> */}

//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             label={t('text.TotalFile')}
//             value={animatedAdvertisement}
//             iconSrc={Active}
//             onClick={() => setShowTotalFileModal(true)}
//             isSmallScreen={isSmallScreen}
//             theme={theme}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             label={t('text.TotalEPCApproved')}
//             value={animatedApproved}
//             iconSrc={Active}
//             onClick={() => setShowTotalEPCApproved(true)}
//             isSmallScreen={isSmallScreen}
//             theme={theme}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             label={t('text.TotalEPCPending')}
//             value={animatedVacantHolding}
//             iconSrc={Active}
//             onClick={() => setShowTotalEPCPending(true)}
//             isSmallScreen={isSmallScreen}
//             theme={theme}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             label={t('text.TotalFileIssue')}
//             value={animatedApplied}
//             iconSrc={Active}
//             isSmallScreen={isSmallScreen}
//             theme={theme}
//           />
//         </Grid>

//         {/* Charts Section */}
//         <Grid item xs={12} md={6}>
//           <Card
//             elevation={4}
//             sx={{
//               height: isSmallScreen ? '320px' : '380px',
//               display: 'flex',
//               flexDirection: 'column',
//               borderRadius: 2,
//               overflow: 'hidden'
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.main,
//                 color: theme.palette.primary.contrastText,
//                 p: 2,
//                 display: 'flex',
//                 alignItems: 'center'
//               }}
//             >
//               <Typography variant="h6" component="div">
//                 {t("text.Zone")}
//               </Typography>
//             </Box>
//             <Box sx={{
//               flexGrow: 1,
//               display: 'flex',
//               alignItems: 'center',
//               p: isSmallScreen ? 1 : 2
//             }}>
//               {chartData && (
//                 <Chart
//                   chartType="PieChart"
//                   height={isSmallScreen ? '220px' : '280px'}
//                   data={chartData}
//                   options={options1}
//                   chartEvents={[
//                     {
//                       eventName: "select",
//                       callback: ({ chartWrapper }) => handleChartSelect(chartWrapper),
//                     },
//                   ]}
//                   width="100%"
//                 />
//               )}
//             </Box>
//           </Card>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <Card
//             elevation={4}
//             sx={{
//               height: isSmallScreen ? '320px' : '380px',
//               display: 'flex',
//               flexDirection: 'column',
//               borderRadius: 2,
//               overflow: 'hidden'
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.main,
//                 color: theme.palette.primary.contrastText,
//                 p: 2,
//                 display: 'flex',
//                 alignItems: 'center'
//               }}
//             >
//               <Typography variant="h6" component="div">
//                 {t("text.NoticeBoard")}
//               </Typography>
//             </Box>
//             <Box sx={{
//               flexGrow: 1,
//               display: 'flex',
//               alignItems: 'center',
//               p: isSmallScreen ? 1 : 2
//             }}>
//               <NoticeBoard />
//             </Box>
//           </Card>
//         </Grid>

//         <Grid item xs={12}>
//           <Card
//             elevation={4}
//             sx={{
//               height: isSmallScreen ? '400px' : '540px',
//               display: 'flex',
//               flexDirection: 'column',
//               borderRadius: 2,
//               overflow: 'hidden'
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.main,
//                 color: theme.palette.primary.contrastText,
//                 p: 2,
//                 display: 'flex',
//                 alignItems: 'center'
//               }}
//             >
//               <Typography variant="h6" component="div">
//                 {t("text.WardData")}
//               </Typography>
//             </Box>
//             <Box sx={{
//               flexGrow: 1,
//               overflow: 'auto',
//               p: isSmallScreen ? 1 : 2
//             }}>
//               <ZoneWiseWardDashboard />
//             </Box>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Modal components */}
//       <TotalEPCApproved
//         open={showTotalEPCApproved}
//         onClose={() => setShowTotalEPCApproved(false)}
//       />
//       <TotalEPCPending
//         open={showTotalEPCPending}
//         onClose={() => setShowTotalEPCPending(false)}
//       />
//       <TotalFileModal
//         open={showTotalFileModal}
//         onClose={() => setShowTotalFileModal(false)}
//       />
//     </Box>
//   );
// }





